import AssignmentListSection from "./components/assignment-list-section";

const Assignment = () => {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Schools List - Takes remaining height */}
      <div className="h-full">
        <AssignmentListSection />
      </div>
    </div>
  );
};

export default Assignment;
